import { Controller } from "@hotwired/stimulus"

// 파일 입력 컨트롤러 - Design System v3
// 파일 선택, 표시, 초기화 기능 제공
export default class extends Controller {
  static targets = ["input", "filename", "clearButton"]

  connect() {
    this.placeholder = this.filenameTarget.textContent
  }

  click(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  keydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      this.click(event)
    }
  }

  handleChange(event) {
    const file = event.target.files?.[0]

    if (file) {
      this.filenameTarget.textContent = file.name
      this.filenameTarget.classList.remove("text-[var(--gray-500)]")
      this.filenameTarget.classList.add("text-[var(--foreground)]")

      if (this.hasClearButtonTarget) {
        this.clearButtonTarget.classList.remove("hidden")
      }
    } else {
      this.reset()
    }
  }

  clear(event) {
    event.stopPropagation()
    this.inputTarget.value = ""
    this.reset()

    // Dispatch change event for form validation
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  reset() {
    this.filenameTarget.textContent = this.placeholder
    this.filenameTarget.classList.add("text-[var(--gray-500)]")
    this.filenameTarget.classList.remove("text-[var(--foreground)]")

    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.add("hidden")
    }
  }
}
